import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
// import ImageCard from '../ImageCard';

import VideoSection from '../../VideoSection';
import { colors, fontSize } from '../../../constants/styleConstants';
import { TP } from '../../../constants/consts';

const useStyles = makeStyles(() => ({
  viewTitle: {
    fonSize: fontSize.basic,
    color: colors.grey3,
    fontWeight: 'bold',
    marginBottom: 16,
  },
}));

const ArtistVideos = ({ t, videos }) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.viewTitle}>{t(`${TP}.m_ARTIST_VIDEOS`)}</div>
      <div className={classes.content}>
        {videos.length === 0 && t(`${TP}.m_ARTIST_NO_VIDEOS`)}
        <VideoSection records={videos?.data || []} />
      </div>
    </>
  );
};

ArtistVideos.propTypes = {
  videos: PropTypes.object,
  t: PropTypes.func,
};

ArtistVideos.defaultProps = {
  videos: [],
};

export default ArtistVideos;
